import { useMemo } from "react";
import { createPublicClient, http } from "viem";
import { sepolia } from "viem/chains";
import ChainId from "../constants/chainId";
import { DEFAULT_CHAIN_ID } from "@/constants";

export const chainConfig = {
  [ChainId.SEPOLIA]: sepolia,
};

export const rpcUrl = {
  [ChainId.SEPOLIA]: "https://eth-sepolia.public.blastapi.io",
};

const usePublicClient = () => {
  const publicClient = useMemo(() => {
    return createPublicClient({
      chain: chainConfig[DEFAULT_CHAIN_ID],
      transport: http(rpcUrl[DEFAULT_CHAIN_ID]),
    });
  }, []);

  return publicClient;
};

export default usePublicClient;
